import {
  APIPresentationAssetAttributes,
  APIPresentationAttributes,
} from '@ardoq/api-types';

export const toPresentationAsset = (
  presentation: APIPresentationAttributes | APIPresentationAssetAttributes
): APIPresentationAssetAttributes => ({
  ...presentation,
  authorizedSlides: (presentation.authorizedSlides ?? []).map(slideOrId =>
    typeof slideOrId === 'string' ? slideOrId : slideOrId._id
  ),
});
